import CardDiv from "modules/common/card-div/CardDiv";
import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

function TimeOffCanvas({ name, date }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="cursor-pointer" onClick={handleShow}>
        <CardDiv component={name} />
      </div>
      <Offcanvas
        style={{ width: "35vw" }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Slot Booking | {date} | {name}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body></Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default TimeOffCanvas;
